import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Toast } from 'antd-mobile';
import './common.scss';
import toyotaLogo from '../../assets/TOYOTA LOGO - Horizontal.svg';
import matainRecordSvg from '../../assets/matain-record.svg';
import noDataSvg from '../../assets/no-data.svg';
import Loading from 'pages/toyotaOfficialAccount/Loading';
import Error from 'pages/toyotaOfficialAccount/Error';

import { AuthValid } from 'shared/httpHandler';
import { encodeBase64Object } from 'shared/common';
import axios from 'axios';

const typeClass = {
  '一般維修': 'general-maintenance',
  '定期保養': 'regular-maintenance',
  '鈑金維修': 'body-repair'
}

const MaintenanceRecord = () => {
  const [token, setToken] = useState('');
  const [carNo, setCarNo] = useState('');
  const [lineId, setLineId] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [records, setRecords] = useState([]);
  const [displayError, setDisplayError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [expandedRecords, setExpandedRecords] = useState(new Set());

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get('token');

    try {
      const payload = AuthValid.parseJwt(token);
      setToken(token);
      setLineId(payload.sub);
      setCarNo(payload.carNo);
    } catch (error) {
      console.error('Failed to parse JWT token:', error);
      setErrorMessage("您正前往的頁面已失效，請重新操作LINE官方帳號選單。");
      setDisplayError(true);
    }
  }, []);

  const getMaintenanceRecord = async () => {
    setIsLoading(true);
    try {
      const queryParams = new URLSearchParams(encodeBase64Object({
        car_no: carNo,
        auth_token: token
      }));
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/maintenance?${queryParams.toString()}`);
      setRecords(response.data.data || []);
    } catch (error) {
      console.error('Failed to get maintenance record:', error);
      if (error.status >= 400 && error.status <= 499) {
        setErrorMessage("您正前往的頁面已失效，請重新操作LINE官方帳號選單。");
      }
      setDisplayError(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (token && lineId && carNo) {
      getMaintenanceRecord();
    }
  }, [token, lineId, carNo]);

  // 確保頁面加載時滾動到頂部
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const handleCardClick = async (work_id) => {
    // if (url) {
    //   window.location.href = url;

    //   // 因為這個昕力資訊提供的連結只能開一次
    //   // 所以每次被點擊後都重新取得保修紀錄，取得新的連結
    //   setTimeout(() => {
    //     getMaintenanceRecord();
    //   }, 1500);
    // } else {
    //   Toast.show('系統忙碌中，請稍後再試');
    // }
    setIsLoading(true);
    try {
      const queryParams = new URLSearchParams(encodeBase64Object({
        car_no: carNo,
        work_id: work_id,
        auth_token: token
      }));
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/maintenance_detail?${queryParams.toString()}`);

      if (response.data.success && response.data.data) {
        window.location.href = response.data.data;
      } else {
        Toast.show('系統忙碌中，請稍後再試');
      }
      setIsLoading(false);

    } catch (error) {
      console.error('Failed to get maintenance record:', error);
      if (error.status >= 400 && error.status <= 499) {
        setErrorMessage("您正前往的頁面已失效，請重新操作LINE官方帳號選單。");
      }
      setDisplayError(true);
    }
  };

  const toggleExpanded = (index) => {
    const newExpandedRecords = new Set(expandedRecords);
    if (newExpandedRecords.has(index)) {
      newExpandedRecords.delete(index);
    } else {
      newExpandedRecords.add(index);
    }
    setExpandedRecords(newExpandedRecords);
  };

  // const records = [
  //   {
  //     id: '13A3821',
  //     type: '一般維修',
  //     date: '2025/01/28',
  //     mileage: '35,201 km',
  //     amount: '$1,080',
  //     typeClass: 'general-maintenance'
  //   },
  //   {
  //     id: '46C8451',
  //     type: '定期保養',
  //     date: '2024/09/02',
  //     mileage: '30,054 km',
  //     amount: '$3,500',
  //     typeClass: 'regular-maintenance'
  //   },
  //   {
  //     id: '88D4200',
  //     type: '鈑金維修',
  //     date: '2024/01/27',
  //     mileage: '15,246 km',
  //     amount: '$6,600',
  //     typeClass: 'body-repair'
  //   }
  // ];

  if (isLoading) {
    return <Loading />;
  }

  if (displayError) {
    return <Error message={errorMessage} />;
  }

  return (
    <div className="center-viewport">
      <div className="maintenance-app">
        {/* Toyota Logo */}
        <div className="toyota-header">
          <Link to="/">
            <img className="toyota-logo" src={toyotaLogo} alt="TOYOTA LOGO" style={{ height: '20px', width: 'auto', display: 'block', margin: '0 auto', cursor: 'pointer' }} />
          </Link>
        </div>

        {/* Main Content */}
        <div className="main-content">
          {/* Header */}
          <div className="content-header">
            <div className="header-row">
              <div className="header-text">
                <div className="vehicle-number">{carNo}</div>
                <h1 className="page-title">保修紀錄</h1>
              </div>
              <div className="header-icons">
                <img src={matainRecordSvg} alt="維修記錄icon" />
              </div>
            </div>
            <p className="description">
              因資料量龐大，僅提供近2年內的保修紀錄。
            </p>
          </div>

          {/* Records */}
          <div className="car-list-container">
            {records.map((record, index) => (
              <div
                key={index}
                className="card-container"
              >
                <div className="record-header">
                  <span className="record-id">工單編號 {record.id}</span>
                  {/* <span className={`record-type ${typeClass[record.type] || typeClass["一般維修"]}`}>
                    {record.type}
                  </span> */}
                </div>
                <div className="section-divider" />
                <div className="flex-col">
                  <div className="text-base flex-col-item">
                    <span className="text-dark-base">入廠日期</span>
                    <span className="text-dark-base font-medium">{record.date}</span>
                  </div>
                  <div className="text-base flex-col-item">
                    <span className="text-dark-base">里程數</span>
                    <span className="text-dark-base font-medium">{record.mileage} km</span>
                  </div>
                  <div className="text-base flex-col-item">
                    <span className="text-dark-base">發票金額</span>
                    <span className="text-dark-base font-medium">{record.amount}</span>
                  </div>
                  <div className="text-base flex-col-item">
                    <span className="text-dark-base">顧客需求</span>
                    <div style={{ flex: 1 }}>
                      <span className="text-dark-base font-medium customer-requirements">
                        {!expandedRecords.has(index) && record.type && record.type.length > 50 ? (
                          <span className="customer-requirements-with-more">
                            {record.type.substring(0, 18)}...
                            <span
                              className="view-more-inline"
                              onClick={(e) => {
                                e.stopPropagation();
                                toggleExpanded(index);
                              }}
                            >
                              查看全部
                            </span>
                          </span>
                        ) : (
                          record.type
                        )}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="maintenance-details-btn-container">
                  <button
                    className="maintenance-details-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleCardClick(record.id);
                    }}
                  >
                    查看完整明細
                  </button>
                </div>
              </div>
            ))}
            {records.length === 0 && (
              <div className="card-container">
                <div className="no-data-block">
                  <img src={noDataSvg} alt="no data" className="no-data-img" />
                  <div className="text-muted-base font-medium">目前尚無資料</div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MaintenanceRecord; 